const invoice = {
  // 基本設定情報
  basicInfo: null,
  // インボイスNo (referenceNo)
  // 出荷予定日 (shippingDate)
  // 伝票番号 (ytcNo)

  // 輸入者情報
  consigneeInfo: null,
  // 名前 (consigneeName)
  // 国コード (consigneeCountryCd)
  // 国（表示用） (consigneeCountryName)
  // TaxID区分 (consigneeUsciOcDiv)
  // TaxID区分（表示用） (consigneeUsciDivName)
  // TaxID番号 (consigneeUsciOcCd)
  // 電話番号 (consigneePhone)
  // 郵便番号 (consigneeZip)
  // 州 (stateCd)
  // 州（表示用） (consigneeAddress1)
  // 都市 (consigneeAddress2)
  // 住所 (consigneeAddress3)
  // 会社名・部署名 (consigneeAddress4)

  // 輸出者情報
  shipperInfo: null,
  // 名前 (shipperName)
  // 法人番号・税関輸出入者コード (shipperOrganizationCd)
  // 電話番号 (shipperPhone)
  // 郵便番号 (shipperZip)
  // 都道府県 (shipperAddress1)
  // 市・区・郡 (shipperAddress2)
  // 町・番地・建物名 (shipperAddress3)
  // 会社名・部署名 (shipperAddress4)

  // 出荷予定個数
  pcs: null,
  // クール区分
  coolDiv: null,
  // クール区分（表示用）
  coolDivName: null,

  vatRegisterDiv: null,
  vatRegisterDivName: null,
  vatRegisterNumber: null,

  // 荷物設定情報
  packageInfo: null,
  // Array object 荷物情報
  // パッケージID (packageId)
  // 実重量 (grossWeight)
  // 正味重量 (netWeight)
  // 有償・無償 (paidDiv)
  // 有償・無償（表示用） (paidDivName)
  // 重量単位コード (weightUnitCd)
  // 重量単位コード（表示用） (weightUnitName)
  // 通貨 (currencyCd)
  // 建値 (shipmentTerm)
  // 1番目備考 (note1)
  // 2番目備考 (note2)
  // 品目情報 (itemInfo)
  // 商品価格合計 (itemTotal)

  // お届け先マスタ登録フラグ
  registerConsigneeInfoFlg: null,
  // ご依頼主マスタ登録フラグ
  registerShipperInfoFlg: null,
  // 品目マスタ登録フラグ
  registerItemInfoFlg: null,
  overWriteConfirmFlag: null
};

const state = {
  // 送り状発行情報
  invoice: { ...invoice }
};

const getters = {
  invoice: state => state.invoice
};

const mutations = {
  changeInvoice(state, invoice) {
    // インボイス発行情報
    if (!invoice) {
      return;
    }
    // インボイス発行情報
    const stateInvoice = state.invoice;
    // 基本設定情報
    const basicInfo = invoice.basicInfo;
    if (basicInfo) {
      stateInvoice.basicInfo = basicInfo;
    } else {
      stateInvoice.basicInfo = null;
    }

    // 輸入者情報
    const consigneeInfo = invoice.consigneeInfo;
    if (consigneeInfo) {
      stateInvoice.consigneeInfo = consigneeInfo;
    } else {
      stateInvoice.consigneeInfo = null;
    }

    // 輸出者情報
    const shipperInfo = invoice.shipperInfo;
    if (shipperInfo) {
      stateInvoice.shipperInfo = shipperInfo;
    } else {
      stateInvoice.shipperInfo = null;
    }

    // 出荷予定個数
    stateInvoice.pcs = invoice.pcs;
    // クール区分
    stateInvoice.coolDiv = invoice.coolDiv;
    // クール区分（表示用）
    stateInvoice.coolDivName = invoice.coolDivName;
    // VAT種類
    stateInvoice.vatRegisterDiv = invoice.vatRegisterDiv;
    // VAT種類（表示用）
    stateInvoice.vatRegisterDivName = invoice.vatRegisterDivName;
    // VAT番号
    stateInvoice.vatRegisterNumber = invoice.vatRegisterNumber;

    // 荷物設定情報
    const packageInfo = invoice.packageInfo;
    if (packageInfo) {
      stateInvoice.packageInfo = packageInfo;
    } else {
      stateInvoice.packageInfo = null;
    }

    // お届け先マスタ登録フラグ
    stateInvoice.registerConsigneeInfoFlg = invoice.registerConsigneeInfoFlg;
    // ご依頼主マスタ登録フラグ
    stateInvoice.registerShipperInfoFlg = invoice.registerShipperInfoFlg;
    // 品目マスタ登録フラグ
    stateInvoice.registerItemInfoFlg = invoice.registerItemInfoFlg;
    stateInvoice.overWriteConfirmFlag = invoice.overWriteConfirmFlag;
  },

  saveInvoiceInfo(state, invoice) {
    if (!invoice) {
      return;
    }
    const invoiceState = state.invoice;
    if (!invoiceState.basicInfo) {
      invoiceState.basicInfo = {};
    }

    // インボイスNo
    if (invoice.referenceNo) {
      invoiceState.basicInfo.referenceNo = invoice.referenceNo;
    }
    // 出荷予定日
    if (invoice.shippingDate) {
      invoiceState.basicInfo.shippingDate = invoice.shippingDate;
    }
  },
  clearInvoiceInfo(state) {
    const invoiceClear = {
      basicInfo: null,
      consigneeInfo: null,
      shipperInfo: null,
      pcs: null,
      coolDiv: null,
      coolDivName: null,
      vatRegisterDiv: null,
      vatRegisterDivName: null,
      vatRegisterNumber: null,
      packageInfo: null,
      registerConsigneeInfoFlg: null,
      registerShipperInfoFlg: null,
      registerItemInfoFlg: null,
      overWriteConfirmFlag: null
    };
    state.invoice = invoiceClear;
  }
};

export default {
  state,
  getters,
  mutations
};
